import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { CALENDLY_URL } from "@/lib/constants";

export default function FinalCTA() {
  return (
    <section className="py-20 md:py-28 bg-gradient-hero text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-radial pointer-events-none" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-accent/15 blur-3xl pointer-events-none" />
      <div className="container relative max-w-3xl text-center">
        <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-extrabold text-balance reveal">
          Bereit für Deine <span className="text-accent">finanzielle Zukunft?</span>
        </h2>
        <p className="mt-6 text-lg md:text-xl text-white/80 reveal">
          Vereinbare jetzt Dein unverbindliches Erstgespräch und starte in eine sichere und renditestarke Zukunft.
        </p>
        <div className="mt-10 flex justify-center reveal">
          <Button asChild variant="hero" size="xl">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              Jetzt Erstgespräch vereinbaren <ArrowRight className="w-5 h-5" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
